<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="field-row">
        <div class="field">
          <p class="label">{{ step.subPregunta }}</p>

          <div class="fechaBlock">
            <select v-model="diaSelected">
              <option
                v-for="dia in dias"
                :value="dia"
                :key="dia"
                :hidden="dia == 'Dia'"
                >{{ dia }}</option
              >
            </select>

            <select v-model="mesSelected">
              <option
                v-for="mes in meses"
                :value="mes"
                :key="mes"
                :hidden="mes == 'Mes'"
                >{{ mes }}</option
              >
            </select>

            <select v-model="anioSelected">
              <option
                v-for="anio in anios"
                :value="anio"
                :key="anio"
                :hidden="anio == 'Anio'"
                >{{ anio }}</option
              >
            </select>
          </div>
        </div>
        <div v-if="errorFecha" class="noValido">{{ errorFecha }}</div>
      </div>
    </div>

    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="siguiente()">
      Siguiente</a
    >
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";
export default {
  store: ["step"],

  props: {
    fechaDefault: {
      type: String
    }
  },

  data() {
    return {
      anioSelected: "Año",
      mesSelected: "Mes",
      diaSelected: "Dia",
      errorFecha: "",
      errorServidor: "",
      dias: [],
      meses: [
        "Mes",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      anios: []
    };
  },

  mounted() {
    let vm = this;
    this.$eventBus.$on("errorServidor", function(mensaje) {
      console.log("Fecha Error devuelto por el servidor: " + mensaje);
      vm.errorFecha = mensaje;
    });

    console.log("fechaDefault:" + this.fechaDefault);

    let i = 1;
    this.dias.push("Dia");
    for (i; i <= 31; ++i) {
      this.dias.push(i);
    }

    i = 1948;
    let anoActual = new Date().getFullYear();
    console.log(anoActual);
    this.anios.push("Año");
    for (i; i <= anoActual; ++i) {
      this.anios.push(i);
    }

    let valorAnterior = actions.getSeleccionAnterior(this.$route.params.np);
    if (valorAnterior != null || this.fechaDefault != null)
      this.parseFecha(
        valorAnterior != null ? valorAnterior : this.fechaDefault
      );
  },

  methods: {
    siguiente: async function() {
      let fecha =
        this.lpad(this.diaSelected, 2) +
        this.lpad(this.meses.indexOf(this.mesSelected), 2) +
        this.anioSelected.toString();

      actions.setSeleccion(this.$route.params.np, fecha);
      console.log("Fecha:" + fecha);
      this.$emit("elegido", fecha);
    },

    parseFecha(fecha) {
      this.diaSelected = parseInt(fecha.substring(0, 2));
      this.mesSelected = this.meses[parseInt(fecha.substring(2, 4))];
      this.anioSelected = parseInt(fecha.substring(4, 8));
    },

    lpad(number, length) {
      var str = "" + number;
      while (str.length < length) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>

<style lang="scss" scoped>
.fechaBlock {
  display: flex;
}
</style>
